import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import ForgotPasswordLink from '../components/ForgotPasswordLink'
import Question from '../components/Question'
import ViewLayout, { classes } from '../components/ViewLayout'
import { AuthState } from '../types/AuthState'
import type { Customization } from '../types/Customization'

type HelpProps = {
  authState?: AuthState
  customization?: Customization
}

const defaultEnrollmentTeamName = 'McKinsey'

const Help = ({ authState, customization }: HelpProps): JSX.Element => {
  const team = customization?.enrollmentTeamName || defaultEnrollmentTeamName
  return (
    <ViewLayout>
      <section className={classes.wrappingBox}>
        <h1> Getting Help </h1>
        <Grid item span={12}>
          <Question title="I don't know my password">
            <p>
              If you have lost or forgotten your password, you can trigger a password reset by clicking{' '}
              <ForgotPasswordLink authState={authState} rawText={true} text="here" />.
            </p>
          </Question>
        </Grid>
        <Grid item span={12}>
          <Question title="I don't know my username">
            <p>
              When your {team} account is created, an email containing a link to activate your account will be sent to
              you.
              <br />
              If you received this email, you can find your username there. If you did not receive this email, please
              reach out to your {team} contact.
            </p>
          </Question>
        </Grid>
        <Grid item span={12}>
          <Question title="Register a new device">
            <p>
              In order to register a new device for MFA, please contact{' '}
              <a
                className="link"
                href="mailto:support@mckinsey.com"
                style={{ color: customization?.buttonBackgroundColor }}
              >
                support@mckinsey.com
              </a>
              . <br />
              The support team will send further instructions to your configured email as soon as possible.
            </p>
          </Question>
        </Grid>
        <Grid>
          <Question title="My activation link has expired">
            <p>
              In order to restart the activation process, please reach out to your {team} contact. The support team will
              send further instructions to your configured email as soon as possible.
            </p>
          </Question>
        </Grid>
      </section>
    </ViewLayout>
  )
}

export default Help
